import { render } from "./Notices.vue?vue&type=template&id=f6b40e86&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"

import "./Notices.vue?vue&type=style&index=0&id=f6b40e86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b40e86"]])

export default __exports__